import {
  EUserRole,
  MembershipStatus,
  MembershipTermAlertSearchFilter,
  UserSearchInput_Filter,
  UserSearchInput_Filter_EAccountStatus,
} from '@/graphql-types/globalTypes';

export enum UsersQueryStateMembershipStatus {
  ALL = 'ALL',
  NOT_A_MEMBER = 'NOT_A_MEMBER',
  MEMBER = 'MEMBER',
}

export enum UsersQueryStateAccountStatus {
  ALL = 'ALL',
  NOT_INVITED = 'NOT_INVITED',
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

export type IUsersQueryState = {
  page: number;
  searchText: string;
  accountStatus: UserSearchInput_Filter_EAccountStatus[];
  membershipStatus: MembershipStatus[];
  membershipType: string[];
  role: EUserRole[];
  termAlerts: MembershipTermAlertSearchFilter[];
};

export type IUsersQueryAction =
  | {
      searchText: string;
    }
  | {
      accountStatus: UserSearchInput_Filter_EAccountStatus[];
    }
  | { membershipStatus: MembershipStatus[] }
  | { role: EUserRole[] }
  | { page: number }
  | { membershipType: string[] }
  | { termAlerts: MembershipTermAlertSearchFilter[] };

/** Non-deactivated account statuses used for Contacts "All" (excludes archived). */
export const NON_DEACTIVATED_ACCOUNT_STATUSES: UserSearchInput_Filter_EAccountStatus[] =
  [
    UserSearchInput_Filter_EAccountStatus.NOT_INVITED,
    UserSearchInput_Filter_EAccountStatus.INVITED,
    UserSearchInput_Filter_EAccountStatus.ACTIVE,
  ];

export type IQueryStateToFilterOptions = {
  /** When true, only deactivated (archived) users are returned. */
  archivedOnly?: boolean;
};

export const queryStateToFilter = (
  queryState: IUsersQueryState,
  options?: IQueryStateToFilterOptions
): UserSearchInput_Filter => {
  if (options?.archivedOnly) {
    return {
      searchText: queryState.searchText,
      accountStatusV2: [UserSearchInput_Filter_EAccountStatus.DEACTIVATED],
      membershipTypeNames: null,
      membershipStatusV3: null,
      role: null,
      termAlerts: null,
    };
  }

  // Contacts listing/export: never include archived users
  const withoutDeactivated = queryState.accountStatus.filter(
    (status) => status !== UserSearchInput_Filter_EAccountStatus.DEACTIVATED
  );

  return {
    searchText: queryState.searchText,
    accountStatusV2: withoutDeactivated.length
      ? withoutDeactivated
      : NON_DEACTIVATED_ACCOUNT_STATUSES,
    membershipTypeNames: queryState.membershipType.length
      ? queryState.membershipType
      : null,
    membershipStatusV3: queryState.membershipStatus.length
      ? queryState.membershipStatus
      : null,
    role: queryState.role.length ? queryState.role : null,
    termAlerts: queryState.termAlerts.length ? queryState.termAlerts : null,
  };
};
